import { HOST_EHR, ORIGIN, URL_BFF, EHR_SERVICE } from "../util/constants";
import { Injectable } from "@angular/core";
import { RequestService } from "./request.service";
import { AuthenticateService } from "./authenticate.service";
import { Router } from "@angular/router";
import * as moment from "moment";
import { html2json } from "html2json";
import { LoadingController, ToastController } from "@ionic/angular";
import { Organization } from "../models/organization.model";

@Injectable({
  providedIn: "root",
})
export class DocumentService {
  constructor(
    private http: RequestService,
    private auth: AuthenticateService,
    private router: Router,
    private toastController: ToastController,
    private loadingCtrl: LoadingController
  ) { }

  public async loadDetail(atendimento) {
    var datas: any = [];
    let resultado: any;
    if (atendimento.tipo == "RESULTADO DE EXAMES") {
      let document: any = await this.getReadFull(atendimento.id + "/$document");
      if (document) {
        for (let data of document.entry) {
          if (data.resource.resourceType == "Observation") {
            if (data.resource.valueCodeableConcept) {
              let system: any = await this.getReadSystem(
                data.resource.valueCodeableConcept.coding[0]
              );
              if (system && system.parameter) {
                resultado = system.parameter.find(
                  (dataSys) => dataSys.name == "display"
                ).valueString;
              } else {
                resultado = "-";
              }
            } else if (data.resource.valueQuantity) {
              resultado =
                data.resource.valueQuantity.value +
                " " +
                data.resource.valueQuantity.unit;
              if (data.resource.interpretation) {
                let systemInter: any = await this.getReadSystem(
                  data.resource.interpretation[0].coding[0]
                );
                if (systemInter && systemInter.parameter) {
                  resultado =
                    resultado +
                    " " +
                    systemInter.parameter.find(
                      (dataSys) => dataSys.name == "display"
                    ).valueString;
                }
              } else {
                resultado =
                  resultado +
                  " Não foi informado pelo laboratório a interpretação desse valor";
              }
            }
          }

          if (data.resource.resourceType == "Composition") {
            if (data.resource.author && data.resource.author.length > 0) {
              let org: any;
              if (data.resource.author[0].reference) {
                org = await this.getReadFull(
                  HOST_EHR + "/api/fhir/r4/" + data.resource.author[0].reference
                );
              } else {
                org = await this.getReadFull(
                  HOST_EHR +
                  "/api/fhir/r4/Organization/" +
                  data.resource.author[0].identifier.value
                );
              }

              if (org) {
                let email: any = {};
                if (org.telecom) {
                  email = org.telecom.find((item) => item.system === "email");
                }
                datas = {
                  nome: atendimento.nome,
                  cnes: org.id,
                  orgName: org.name,
                  orgContact: email.value,
                  dataColeta: document.entry[1].resource.effectiveDateTime
                    ? moment
                      .utc(
                        document.entry[1].resource.effectiveDateTime,
                        "YYYY-MM-DD HH:mm"
                      )
                      .local()
                      .format("YYYY-MM-DD HH:mm")
                    : "-",
                  dataResultado: document.entry[1].resource.issued
                    ? moment
                      .utc(
                        document.entry[1].resource.issued,
                        "YYYY-MM-DD HH:mm"
                      )
                      .local()
                      .format("YYYY-MM-DD HH:mm")
                    : "-",
                  resultado: resultado,
                  paisColeta: org.address
                    ? org.address[0].country.substr(0, 3)
                    : "-",
                };
              }
            }
          }
        }
      }
    }

    return datas;
  }

  public async loadDetailCMD(atendimento): Promise<any> {
    var datas = {};

    let document = await this.getReadFullCmd(
      `${atendimento.fullpath}/$document?`
    );
    if (document && document.entry) {
      if (document.entry) {
        await Promise.all(document.entry.map(async (element) => {
          if (element.resource.resourceType != "Compositor") {
            datas["diagnosticos"] = [];
            datas["procedimentos"] = [];
            if (element.resource.resourceType == "Composition") {
              if (element.resource.author) {
                let org = await this.getReadSystem(
                  element.resource.author[0].identifier
                );
                datas["org"] = {
                  cnes: org.id ? org.id : "-",
                  nome: org.name ? org.name : "-",
                  telefone: org.telecom
                    ? org.telecom.find((item) => item.system == "phone")
                    : "-",
                };
              }

              if (
                element.resource &&
                element.resource.text &&
                element.resource.text.div
              ) {
                let div: any = this.getList(
                  html2json(element.resource.text.div)
                );
                datas["geral"] = div;
              }
            }

            if (element.resource.resourceType == "Encounter") {
              let system = await this.getReadSystem(
                element.resource.hospitalization.admitSource.coding[0]
              );
              if (system && system.parameter) {
                datas["procedencia"] = system.parameter.find(
                  (data) => data.name == "display"
                ).valueString;
              } else {
                datas["procedencia"] = "-";
              }

              let classEncounter = await this.getReadSystem(
                element.resource.class
              );
              if (classEncounter && classEncounter.parameter) {
                datas["modalidade"] = classEncounter.parameter.find(
                  (data) => data.name == "display"
                ).valueString;
              } else {
                datas["modalidade"] = "-";
              }

              let dischargeDisposition = await this.getReadSystem(
                element.resource.hospitalization.dischargeDisposition.coding[0]
              );
              if (dischargeDisposition && dischargeDisposition.parameter) {
                datas["motivo"] = dischargeDisposition.parameter.find(
                  (data) => data.name == "display"
                ).valueString;
              } else {
                datas["motivo"] = "-";
              }

              let priority = await this.getReadSystem(
                element.resource.priority.coding[0]
              );
              if (priority && priority.parameter) {
                datas["carater"] = priority.parameter.find(
                  (data) => data.name == "display"
                ).valueString;
              } else {
                datas["carater"] = "-";
              }

              if (element.resource.reasonReference) {
                element.resource.reasonReference.forEach(async (element) => {
                  let ref = element.reference.split("/");
                  let reference = document.entry.find((data) => {
                    return (
                      data.resource.id == ref[1] &&
                      data.resource.resourceType == ref[0]
                    );
                  });
                  if (reference) {
                    //console.log(element)
                    let term = await this.getReadSystem(
                      reference.resource.code.coding[0]
                    );
                    let terminologia = "-";
                    let problem = "-";
                    if (term && term.parameter) {
                      terminologia = term.parameter.find(
                        (data) => data.name == "name"
                      ).valueString;
                      problem =
                        reference.resource.code.coding[0].code +
                        " " +
                        term.parameter.find((data) => data.name == "display")
                          .valueString;
                    }
                    let diagnostico = {
                      categoria: "Principal",
                      presenca:
                        element.extension && element.extension[0].valueBoolean
                          ? "Sim"
                          : "Não",
                      problema: problem,
                      terminologia,
                    };
                    datas["diagnosticos"].push(diagnostico);
                  }
                });
              }

              element.resource.diagnosis.forEach(async (element) => {
                if (element.condition.reference.includes("Condition")) {
                  let ref = element.condition.reference.split("/");
                  let reference = document.entry.find((data) => {
                    return (
                      data.resource.id == ref[1] &&
                      data.resource.resourceType == ref[0]
                    );
                  });
                  if (reference) {
                    let term = await this.getReadSystem(
                      reference.resource.code.coding[0]
                    );
                    let terminologia = "-";
                    let problem = "-";
                    if (term && term.parameter) {
                      terminologia = term.parameter.find(
                        (data) => data.name == "name"
                      ).valueString;
                      problem =
                        reference.resource.code.coding[0].code +
                        " " +
                        term.parameter.find((data) => data.name == "display")
                          .valueString;
                    }
                    let diagnostico = {
                      categoria: "Secundario",
                      presenca:
                        element.condition.extension &&
                          element.condition.extension[0].valueBoolean
                          ? "Sim"
                          : "Não",
                      problema: problem,
                      terminologia,
                    };
                    datas["diagnosticos"].push(diagnostico);
                  }
                }

                if (element.condition.reference.includes("Procedure")) {
                  let ref = element.condition.reference.split("/");
                  let reference = document.entry.find((data) => {
                    return (
                      data.resource.id == ref[1] &&
                      data.resource.resourceType == ref[0]
                    );
                  });
                  //console.log(reference)
                  let term = await this.getReadSystem(
                    reference.resource.code.coding[0]
                  );
                  let terminologia = "-";
                  let procedimentoname = "-";
                  if (term && term.parameter) {
                    terminologia = term.parameter.find(
                      (data) => data.name == "name"
                    ).valueString;
                    try {
                      procedimentoname =
                        reference.resource.code.coding[0].code +
                        " " +
                        term.parameter.find((data) => data.name == "display")
                          .valueString;
                    } catch (err) {

                    }

                  }
                  let profissionais = [];
                  if (reference.resource.performer) {
                    reference.resource.performer.forEach(async (elementIn) => {
                      let vinc = elementIn.actor.identifier.value.split("-");
                      let proff = await this.getReadFull(
                        HOST_EHR + "/api/fhir/r4/Practitioner/" + vinc[0]
                      );
                      let proffRole = await this.getReadFull(
                        HOST_EHR +
                        "/api/fhir/r4/PractitionerRole/" +
                        elementIn.actor.identifier.value
                      );
                      let cbo = await this.getReadSystem(
                        elementIn.function.coding[0]
                      );
                      //console.log('cbo', cbo)
                      let prf = {
                        cbo: cbo
                          ? cbo.parameter.find((data) => data.name == "code")
                            .valueCode +
                          " - " +
                          cbo.parameter.find((data) => data.name == "display")
                            .valueString
                          : "-",
                        cns: vinc[0],
                        nome: proff.name[0].text,
                      };
                      profissionais.push(prf);
                    });
                  }
                  let financiamento = "-";
                  if (element.condition.extension) {
                    let cable = await this.getReadSystem(
                      element.condition.extension[0].valueCodeableConcept
                        .coding[0]
                    );
                    if (cable && cable.parameter) {
                      financiamento = cable.parameter.find(
                        (data) => data.name == "display"
                      ).valueString;
                    }
                  }
                  let proced = "-";

                  if (reference.resource.code) {
                    let cable = await this.getReadSystem(
                      reference.resource.code.coding[0]
                    );
                    if (cable && cable.parameter) {
                      try {
                        proced = cable.parameter.find(
                          (data) => data.name == "display"
                        ).valueString;
                      } catch (err) {

                      }

                    }
                  }
                  let performedDateTime = "-";
                  if (reference.resource.performedDateTime) {
                    let date = reference.resource.performedDateTime.split("-");
                    performedDateTime = date.reverse().join("/");
                  }
                  let procedimento = {
                    data: performedDateTime,
                    procedimento: procedimentoname,
                    terminologia,
                    qt: reference.resource.extension[0].valuePositiveInt
                      ? reference.resource.extension[0].valuePositiveInt
                      : "-",
                    qtTotal: reference.resource.extension[0].valuePositiveInt
                      ? reference.resource.extension[0].valuePositiveInt
                      : "-",
                    profissionais,
                    financiamento,
                    visible: false,
                  };

                  if (datas["procedimentos"].length) {
                    datas["procedimentos"].forEach((item) => {
                      if (
                        item.data == procedimento.data &&
                        item.financiamento == procedimento.financiamento &&
                        item.qt == procedimento.qt &&
                        item.terminologia == procedimento.terminologia
                      ) {
                        item.qtTotal++;
                      }
                    });
                  } else {
                    datas["procedimentos"].push(procedimento);
                  }
                }
              });
            }
          }
        }));
      }
    }
    return datas;
  }

  getPeriod(list) {
    if (list.dtStart && list.dtEnd) {
      let days = moment(list.dtEnd).diff(moment(list.dtStart), "days");
      if (days <= 1) {
        return days + " dia";
      } else {
        return days + " dias";
      }
    }
  }

  async readContentSumario(data) {
    let result = {};

    if (data.resource.resourceType == "Encounter") {
      if (data.resource.period) {
        result = {
          nome: "Periodo da consulta",
          valor:
            moment(data.resource.period.start).format("DD/MM/YYYY HH:mm") +
            " - " +
            moment(data.resource.period.end).format("DD/MM/YYYY HH:mm"),
        };
      }
    }

    if (data.resource.resourceType == "Observation") {
      let nome, value;
      if (data.resource.code) {
        let code = data.resource.code.coding.shift();
        if (code.code == "ANAMNESE_TEXTO_CORRIDO") {
          nome = "Descrição";
        } else {
          nome = code.code;
        }
        if (data.resource.valueString) {
          value = data.resource.valueString;
        }
        if (data.resource.valueInteger) {
          value = data.resource.valueInteger;
        }
        result = {
          nome: nome,
          valor: value,
        };
      }
    }
    return result;
  }

  getList(htmlParse) {
    var result = {};
    if (htmlParse && htmlParse.child) {
      htmlParse.child.forEach((data) => {
        if (data && data.child) {
          data.child.forEach((element) => {
            if (element.attr && element.attr.id && element.child) {
              result[element.attr.id] = element.child[0].text;
            }
          });
        }
      });
    }

    return result;
  }

  public async loadDetailOld(atendimento) {
    let document = await this.getRead(
      `Composition/${atendimento.id}/$document?`
    );
    //console.log('atendimento', document)
    if (document && document.entry) {
    }
    let detail = {};
    if (!atendimento.detailType) {
      const line = this.unwrap(atendimento.detail);
      const keys = Object.keys(line);
      const filter = [];
      keys.forEach((element) => {
        if (
          (element != "name.value" && element.includes("name.value")) ||
          element.includes("value.value")
        ) {
          filter.push(element);
        }
      });
      detail = this.loadValues(filter, line);
    } else {
      //console.log(atendimento)
      detail = this.loadFhir(atendimento.detail, atendimento.nome);
    }
    return detail;
  }

  unwrap(obj, prefix?) {
    var res = {};
    if (obj && Object.keys(obj)) {
      for (var k of Object.keys(obj)) {
        var val = obj[k],
          key = prefix ? prefix + "." + k : k;
        if (typeof val === "object") {
          Object.assign(res, this.unwrap(val, key)); // <-- recursion
        } else {
          res[key] = val;
        }
      }
    }
    return res;
  }

  loadValues(filter, line) {
    const result = {};
    filter.forEach((keys) => {
      this.stringToObj(keys, line[keys], result);
    });
    //console.log(result);
    return result;
  }

  stringToObj(path, value, obj) {
    var objValue = value;
    try {
      objValue = JSON.parse(value);
    } catch (e) { }

    path = path.replace(".data", "");
    path = path.replace(".data", "");
    let parts = path.split("."),
      part;
    const last = parts.pop();
    while ((part = parts.shift())) {
      if (typeof obj[part] != "object") obj[part] = {};
      obj = obj[part];
    }
    if (
      obj.hasOwnProperty(last) &&
      obj[last] &&
      obj[last].constructor === Array
    ) {
      obj[last].push(objValue);
    } else if (obj.hasOwnProperty(last) && obj[last]) {
      var objArray = [];
      objArray.push(obj[last]);
      objArray.push(objValue);
      obj[last] = objArray;
    } else {
      obj[last] = objValue;
    }
  }
  expand(str, value) {
    const items = str.split(".");
    const output = {};
    let ref = output;
    for (let i = 0; i < items.length - 1; i++) {
      ref[items[i]] = {};
      ref = ref[items[i]];
    }
    ref[items[items.length - 1]] = value;
    return output;
  }

  loadFhir(detail, tipo) {
    const result = [];
    const keys = Object.keys(detail);
    let valid = true;
    for (const key of keys) {
      if (typeof detail[key] === "string" || typeof detail[key] === "number") {
        result.push(this.setObj(key, detail[key]));
      }
      if (typeof detail[key] === "object") {
        if (detail[key].display) {
          result.push(this.setObj(key, detail[key].display, detail[key].code));
          valid = false;
        } else if (detail[key].value) {
          result.push(this.setObj(key, detail[key].value, detail[key].code));
          valid = false;
        } else if (detail[key].reference) {
          result.push(this.setObj(key, detail[key].reference));
          valid = false;
        } else if (detail[key].coding) {
          for (const it of detail[key].coding) {
            result.push(this.setObj(key, it.display + " code " + it.code));
            valid = false;
          }
        }
        if (detail[key] instanceof Array && valid) {
          const obj = { name: { value: key }, items: [] };
          for (const it of detail[key]) {
            if (it.text) {
              result.push(this.setObj(key, it.text));
            }
            if (it.display) {
              obj.items.push(this.setObj(key, it.display, it.code));
            } else if (it.value) {
              obj.items.push(this.setObj(key, it.value, it.code));
            } else if (it.reference) {
              obj.items.push(this.setObj(key, it.reference));
            } else if (it.coding) {
              for (const ite of it.coding) {
                obj.items.push(
                  this.setObj(key, ite.display + " code " + ite.code)
                );
              }
            }
          }
          result.push(obj);
        }
      }
    }
    return { content: [{ name: { value: tipo }, items: result }] };
  }

  setObj(key, value, code?) {
    let cd = "";
    if (code) {
      cd = " " + code;
    }
    return {
      name: {
        value: key,
      },
      value: {
        value: value + cd,
      },
    };
  }

  index(obj, is, value) {
    if (typeof is === "string") {
      return this.index(obj, is.split("."), value);
    } else if (is.length === 1 && value !== undefined) {
      return (obj[is[0]] = value);
    } else if (is.length === 0) {
      return obj;
    } else {
      return this.index(obj[is[0]], is.slice(1), value);
    }
  }

  async getRead(reference) {
    return await this.http
      .get(HOST_EHR + "/api/fhir/r4/" + reference, null, this.getHeadersUser())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        if (error.error && error.error.issue) {
          error.error.issue.forEach((element) => {
            this.auth.exceptionMsg(element.diagnostics, 3000);
            return [];
          });
        }
        return [];
      });
  }

  async getReadFullCmd(reference) {
    return await this.http
      .get(reference, null, this.getHeadersUser())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        if (error.error && error.error.issue) {
          error.error.issue.forEach((element) => {
            this.auth.exceptionMsg(element.diagnostics, 3000);
            return [];
          });
        }
        return [];
      });
  }

  async getReadFull(reference) {
    return await this.http
      .get(reference, null, this.getHeadersUser())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        if (error.error && error.error.issue) {
          return [];
        }
        return [];
      });
  }

  async getReadSystem(reference) {
    return await this.http
      .get(
        HOST_EHR +
        "/api/fhir/r4/CodeSystem/$lookup?system=" +
        reference.system +
        "&code=" +
        (reference.code ? reference.code : reference.value),
        null,
        this.getHeadersUser()
      )
      .then((data) => {
        return data;
      })
      .catch((error) => {
        if (error.error && error.error.issue) {
          return [];
        }
        return [];
      });
  }

  getHeadersUser() {
    let server = JSON.parse(localStorage.getItem("app_icp_token"));
    const httpOptions = {
      "Content-Type": "application/json",
      //'X-Authorization-Origin': ORIGIN,
      //'X-Authorization-Audience': 'prosus.saude.gov.br',
      //'X-Authorization-Server': 'CN=RNDS:PROSUS,CN=AC-RESTRITA-RNDS,O=DATASUS,C=BR',
      "X-Authorization-Server": "Bearer " + server.access_token,
      Authorization: "Bearer " + this.auth.getAuthorizationToken(),
    };

    return httpOptions;
  }

  async download(atendimento) {
    let server = JSON.parse(localStorage.getItem("app_icp_token"));
    let _self = this;
    const loading = await this.loadingCtrl.create();
    await loading.present();
    var headers = new Headers();
    headers.append("Location", atendimento.id);
    //headers.append("X-Authorization-Audience", 'conectesus-app.saude.gov.br');
    //headers.append("Location", 'https://ehr-services.dev.saude.gov.br/api/fhir/r4/Bundle/71547896-df66-4ff5-8da6-8a11ab13965f-r3x7');
    let jwtDecode: any = await this.auth.getDecodeToken();
    headers.append("X-Authorization-Server", "Bearer " + server.access_token);
    headers.append(
      "Authorization",
      "Bearer " + this.auth.getAuthorizationToken()
    );
    fetch(URL_BFF + "/api/repo/resultadoExame", { headers })
      .then((resp) => {
        return resp.blob();
      })
      .then(async (blob) => {
        if (
          blob.type === "application/pdf" ||
          blob.type === "application/octet-stream"
        ) {
          const url = window.URL.createObjectURL(blob);
          const element = document.createElement("a");
          // element.setAttribute('href', 'data:attachment/image' + base64);
          element.setAttribute("href", url);
          element.setAttribute("download", "resultado_exame.pdf");
          document.body.appendChild(element);
          element.click();
          await loading.dismiss();
        } else {
          this.exceptionMsg("Ocorreu um erro ao gerar o PDF do exame.");
          await loading.dismiss();
        }
      });
  }

  async exceptionMsg(msg, duration = 2000) {
    const toast = await this.toastController.create({
      cssClass: "modal-toast",
      message: msg,
      position: "top",
      duration: duration,
    });
    await toast.present();
  }

  async getPdfCertificadoVfa(cns) {
    let server = JSON.parse(localStorage.getItem("app_icp_token"));
    // const loading = await this.loadingCtrl.create();
    // await loading.present();
    var headers = new Headers();

    let jwtDecode: any = await this.auth.getDecodeToken();
    //headers.append("X-Authorization-Audience", 'conectesus-app.saude.gov.br');
    //headers.append("Location", 'https://ehr-services.dev.saude.gov.br/api/fhir/r4/Bundle/71547896-df66-4ff5-8da6-8a11ab13965f-r3x7');
    headers.append("X-Authorization-Server", "Bearer " + server.access_token);
    headers.append(
      "Authorization",
      "Bearer " + this.auth.getAuthorizationToken()
    );

    await fetch(
      `${URL_BFF}/api/vacinacao/certificado/vfa/${cns}/exportar/pdf`,
      { headers }
    )
      .then(async (response) => {
        if (response.status == 200) {
          return response.blob();
        } else {
          return response.json();
        }
      })
      .then(async (data) => {
        if (data.error) {
          return this.exceptionMsg(data.message, 5000);
        } else {
          if (
            data.type.includes("application/pdf") ||
            data.type.includes("application/octet-stream")
          ) {
            const url = window.URL.createObjectURL(data);
            const element = document.createElement("a");
            element.setAttribute("href", url);
            element.setAttribute("download", "CIVP.pdf");
            document.body.appendChild(element);
            element.click();
          } else {
            console.log(data);
            await this.exceptionMsg(
              "Ocorreu um erro ao gerar o PDF de Febre Amarela."
            );
          }
        }
      });
  }

  async downloadVacina() {
    const language = localStorage.getItem("LANGUAGE");
    const padrao = localStorage.getItem("PADRAO");

    let server = JSON.parse(localStorage.getItem("app_icp_token"));
    let _self = this;
    const loading = await this.loadingCtrl.create();
    await loading.present();
    var headers = new Headers();

    let jwtDecode: any = await this.auth.getDecodeToken();
    //headers.append("X-Authorization-Audience", 'conectesus-app.saude.gov.br');
    //headers.append("Location", 'https://ehr-services.dev.saude.gov.br/api/fhir/r4/Bundle/71547896-df66-4ff5-8da6-8a11ab13965f-r3x7');
    headers.append("X-Authorization-Server", "Bearer " + server.access_token);
    headers.append(
      "Authorization",
      "Bearer " + this.auth.getAuthorizationToken()
    );
    fetch(
      URL_BFF +
      "/api/vacinacao/certificado/covid/" +
      jwtDecode.cnsPaciente +
      "/exportar/pdf?lang=" +
      language,
      { headers }
    )
      .then((resp) => {
        return resp.blob();
      })
      .then(async (blob) => {
        if (
          blob.type === "application/pdf" ||
          blob.type === "application/octet-stream"
        ) {
          const url = window.URL.createObjectURL(blob);
          const element = document.createElement("a");
          // element.setAttribute('href', 'data:attachment/image' + base64);
          element.setAttribute("href", url);
          element.setAttribute("download", "carteira-covid.pdf");
          document.body.appendChild(element);
          element.click();
          await loading.dismiss();
        } else {
          this.exceptionMsg("Ocorreu um erro ao gerar o PDF da vacina.");
          await loading.dismiss();
        }
      });
  }

  async downloadVacinaCarteira() {
    const language = localStorage.getItem("LANGUAGE");
    const padrao = localStorage.getItem("PADRAO");

    let jwtDecode: any = await this.auth.getDecodeToken();
    let server = JSON.parse(localStorage.getItem("app_icp_token"));
    let _self = this;
    const loading = await this.loadingCtrl.create();
    await loading.present();
    var headers = new Headers();
    //headers.append("X-Authorization-Audience", 'conectesus-app.saude.gov.br');
    //headers.append("Location", 'https://ehr-services.dev.saude.gov.br/api/fhir/r4/Bundle/71547896-df66-4ff5-8da6-8a11ab13965f-r3x7');
    headers.append("X-Authorization-Server", "Bearer " + server.access_token);
    headers.append(
      "Authorization",
      "Bearer " + this.auth.getAuthorizationToken()
    );
    fetch(
      URL_BFF +
      "/api/vacinacao/certificado/cidadao/" +
      jwtDecode.cnsPaciente +
      "/exportar/pdf?lang=" +
      language,
      { headers }
    )
      .then((resp) => {
        return resp.blob();
      })
      .then(async (blob) => {
        if (
          blob.type === "application/pdf" ||
          blob.type === "application/octet-stream"
        ) {
          const url = window.URL.createObjectURL(blob);
          const element = document.createElement("a");
          // element.setAttribute('href', 'data:attachment/image' + base64);
          element.setAttribute("href", url);
          element.setAttribute("download", "carteira.pdf");
          document.body.appendChild(element);
          element.click();
          await loading.dismiss();
        } else {
          this.exceptionMsg("Ocorreu um erro ao gerar o PDF da vacina.");
          await loading.dismiss();
        }
      });
  }

  async getReadFullVacina(reference) {
    let result = await this.http
      .get(reference, null, await this.getHeadersUser())
      .catch((error) => {
        if (error.error && error.error.issue) {
          return null;
        }
        return null;
      });
    return new Promise(async (resolve, reject) => {
      let instituicao = "";
      let lote = "";
      let vacinador = "";
      let estabelecimento = "";
      if (result.entry) {
        for (let element of result.entry) {
          if (element.resource.resourceType == "Immunization") {
            if (element.resource.lotNumber) {
              lote = element.resource.lotNumber;
            }
            if (element.resource.manufacturer) {
              instituicao = element.resource.manufacturer.display;
            }
            if (element.resource.performer) {
              vacinador = element.resource.performer[0].actor.reference.replace(
                "Practitioner/",
                ""
              );
            }
          }
          if (element.resource.resourceType == "Composition") {
            if (element.resource.author) {
              let org: any;
              if (element.resource.author[0].reference) {
                org = await this.getRead(element.resource.author[0].reference);
              } else {
                org = await this.getRead(
                  "Organization/" + element.resource.author[0].identifier.value
                );
              }
              estabelecimento =
                org.id +
                " - " +
                org.name +
                " - " +
                org.address[0].city +
                " / " +
                org.address[0].state;
            }
          }
        }
      }

      return resolve({
        instituicao,
        lote,
        vacinador,
        estabelecimento,
      });
    });
  }
}
